import { makeChartComp } from '../../util/makeChartComp';
var HistogramChart = makeChartComp('Histogram');
export default HistogramChart;
